import type React from 'react';

import * as styles from './styles';

import {
  DescriptionListDefault,
  InputPlaceholder,
} from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import AddRoundedIcon from '@material-ui/icons/AddRounded';

import firstStep from './components/first-step.png';
import nextStep from './components/next-step.png';
import secondStep from './components/second-step.png';
import thirdStep from './components/third-step.png';

export interface StepByStepEmptyStateProps {
  onCreateNewChecklist: () => void;
}

const StepByStepEmptyState: React.FC<StepByStepEmptyStateProps> = ({
  onCreateNewChecklist,
}) => (
  <div className={styles.stepByStepEmptyState}>
    <div className={styles.steps}>
      <div>
        <img src={firstStep} alt='firsStep' />
        <DescriptionListDefault>
          Clique em ’Criar checklist’ para criar os modelos de Checklists
          necessários para a sua operação
        </DescriptionListDefault>
      </div>
      <img src={nextStep} className={styles.nextStep} alt='nextStep' />
      <div>
        <img src={secondStep} alt='secondStep' />
        <DescriptionListDefault>
          As checklists criadas aparecem no app Cobli Motorista e podem ser
          preenchidas a qualquer momento
        </DescriptionListDefault>
      </div>
      <img src={nextStep} className={styles.nextStep} alt='nextStep' />
      <div>
        <img src={thirdStep} alt='thirdStep' />
        <DescriptionListDefault>
          Veja as checklists preenchidas pelos motoristas aqui no painel e, em
          breve, por e-mail
        </DescriptionListDefault>
      </div>
    </div>
    <div className={styles.addChecklist}>
      <InputPlaceholder>Que tal criar uma checklist agora?</InputPlaceholder>
      <Button
        size='condensed'
        startIcon={<AddRoundedIcon />}
        className='min-w-40'
        onClick={onCreateNewChecklist}
      >
        Criar checklist
      </Button>
    </div>
  </div>
);

export default StepByStepEmptyState;
